import { useLazyQuery } from '@apollo/client';
import getStoreSearchQuery from '../queries/store-search/getStoreSearchQuery';
import { useQuery } from './useQuery';

const useStoreSearch = ({
  zipCode,
  limit,
  radius,
  ssr = false,
  lazy = false
}) => {

  const Query = getStoreSearchQuery();

  const opts = {
    ssr,
    errorPolicy: 'all',
    variables: {
      zipCode,
      limit,
      radius
    }
  };

  if (lazy) {
    return useLazyQuery(Query, opts);
  }
  return useQuery(Query, opts);

};

export default useStoreSearch;
